import { browserMayInvokeVerifyLetterPayments } from "@/utils/clientWrites";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useToast } from "@/hooks/use-toast";

export function VerifyPayments() {
  const { toast } = useToast();

  const handleVerifyPayments = () => {
    if (browserMayInvokeVerifyLetterPayments()) return;

    toast({
      title: "Indisponível no navegador",
      description: "A reconciliação não é chamada por esta tela. Ela fica com o operador.",
    });
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Verificação de Pagamentos</CardTitle>
        <CardDescription>
          A reconciliação de pagamentos não roda no navegador
        </CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-gray-500 mb-4">
          Esta tela não altera status de carta. A conferência fica com o operador, fora do browser.
        </p>
      </CardContent>
      <CardFooter>
        <Button
          onClick={handleVerifyPayments}
          className="w-full"
          type="button"
        >
          Verificação indisponível no navegador
        </Button>
      </CardFooter>
    </Card>
  );
}
